export default "__VITE_ASSET__BtkK0fAt__"